import React, { useEffect, useLayoutEffect } from 'react'
import st from './index.scss'
/**
 * 自定义点我重播按钮，基于播放器dom添加
 * @param {*} player 
 * @returns 
 */
export default function Rebroadcast({ player }) {
    return (
        <div
            className={st['rebroadcast']}
            onClick={() => {
                document.getElementById('rebroadcast_dom').style.display =
                    'none'
                player.currentTime(0)
            }}
        >
            已定位至最新进度，
            <span>点我重播</span>
        </div>
    )
}
